import React from 'react'
import { useCylinder } from '@react-three/cannon'
import { Text } from '@react-three/drei';
import PuckModel from './PuckModel';

export const Puck = (props) => {
    const radius = 0.05;
    const height = 0.03;
    const segments = 6;
    const { position, rotation, value = 0, color = 0x000000 } = props;

    const deg90 = Math.PI / 2;
    const [ref, api] = useCylinder(() => ({
        mass: 0.1,
        position,
        rotation,
        args: [radius, radius, height, segments],
        userData: { value },
        type: 'Dynamic'
    }), null, [position, rotation]);

    return (
        <group ref={ref} api={api}>
            <Text fontSize={.04} font='erica.ttf' scale={[1.2,1.7,1]} rotation={[-deg90, 0, 0]} position={[0, height / 2 + 0.0011, -0.005]}>{value}</Text>
            <Text fontSize={.04} font='erica.ttf' scale={[1.2,1.7,1]}  rotation={[deg90, 0, 0]} position={[0, -height / 2 - 0.0011, 0]}>{value}</Text>
            <PuckModel color={color} />
        </group>
    )
}

export default Puck;